import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import BaseModal from '../types/Base';
import {_removeModal} from '../../../store';

class OrderMessageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: props.content,
    };
    this.executeAction = this.executeAction.bind(this);
  }

  executeAction() {
    const {button} = this.state.content;
    if (button && button.action) {
      button.action(button.data);
    }
    this.props.dispatchRemoveModal(this.state.content);
  }

  render() {
    const {content} = this.state;
    const {dispatchRemoveModal} = this.props;
    return (
      <BaseModal onClose={() => dispatchRemoveModal(content)} title={content.title}>
        {content.body.map((elem) => <div key={elem._id}>
          <div>{JSON.stringify(elem, null, 2)}</div>
          <hr/>
        </div>)}
        <button onClick={this.executeAction}>{(content.button && content.button.text) || 'OK'}</button>
      </BaseModal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchRemoveModal: modal => {
    dispatch(_removeModal(modal));
  },
});

export default connect(null, mapDispatchToProps)(OrderMessageModal);

OrderMessageModal.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.array.isRequired,
    button: PropTypes.shape({
      text: PropTypes.string,
      action: PropTypes.func,
      data: PropTypes.object,
    }),
  }).isRequired,
  dispatchRemoveModal: PropTypes.func.isRequired,
};
